import { Link } from "react-router-dom";

const Exam = (props) => {
  return (
    <div className="item-exam">
      <div className="pic">
        <img src={props.exam?.pic} />
      </div>
      <h4>{props.exam.title}</h4>
      <div className="date">
        <div className="date-details">
          <span>تاریخ شروع : </span>
          <strong>
            {props.exam.start_date === null && props.exam.stop_date === null
              ? "آزاد"
              : props.exam.start_date !== null && props.exam.stop_date === null
              ? "آزاد"
              : props.exam.start_date !== null
              ? props.exam.start_date
              : "آزاد"}
          </strong>
        </div>
        <div className="date-details">
          <span> تاریخ پایان : </span>
          <strong>
            {props.exam.stop_date === null && props.exam.start_date === null
              ? "آزاد"
              : props.exam.stop_date !== null && props.exam.start_date === null
              ? "آزاد"
              : props.exam.stop_date !== null
              ? props.exam.stop_date
              : "آزاد"}
          </strong>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}> <button
        className="start-exam"
      disabled={props.exam.is_exam_active === "inactive" ? true : false}
      >
        {props.exam.is_exam_active === "inactive" ? (
          "شروع آزمون"
        ) : (
        <Link to={`Education/Quiz/${props.exam.id}/1`}>شروع آزمون</Link>
        )}
      </button>
        {props.exam.exam_expired ? <button
          className="start-exam"
        // disabled={props.exam.is_exam_active === "inactive" ? true : false}
        >
          {/* {props.exam.is_exam_active === "inactive" ? (
          "شروع آزمون"
        ) : ( */}
          <Link to={`Education/EndedExam/${props.exam.id}`}>پاسخنامه </Link>
          {/* )} */}
        </button> : <></>}
      </div>
    </div>

  );
};

export default Exam;
